// extracted by mini-css-extract-plugin
module.exports = {"toggleLabel":"GfeToggle_toggleLabel__1F0nm"};